(function () {
  function initEZBERProductVideoPip() {
    const players = document.querySelectorAll('[data-ezber-video-pip]');

    players.forEach(function (player) {
      if (player.dataset.initialized === 'true') return;

      player.dataset.initialized = 'true';

      const video = player.querySelector('video');
      const closeButton = player.querySelector('[data-ezber-video-close]');

      if (!video) return;

      if (closeButton) {
        closeButton.addEventListener('click', function () {
          video.pause();
          player.classList.add('is-closed');
        });
      }

      video.muted = true;
      video.playsInline = true;

      const playVideo = function () {
        const promise = video.play();

        if (promise && typeof promise.catch === 'function') {
          promise.catch(function () {
            // Browser prevented autoplay.
            // The PIP remains visible and can be interacted with normally.
          });
        }
      };

      if (video.readyState >= 2) {
        playVideo();
      } else {
        video.addEventListener('loadeddata', playVideo, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEZBERProductVideoPip);
  } else {
    initEZBERProductVideoPip();
  }

  document.addEventListener('shopify:section:load', initEZBERProductVideoPip);
})();